import { FAQ } from '@tenants';
import { Namespaces } from 'types/locales';

export function createCommercialFaqData(): FAQ {
  const faq_title = `${Namespaces.EXP_COMMERCIAL}:faq.title`;
  const faq_q1_title = `${Namespaces.EXP_COMMERCIAL}:faq.q1.title`;
  const faq_q1_children = `${Namespaces.EXP_COMMERCIAL}:faq.q1.children`;
  const faq_q2_title = `${Namespaces.EXP_COMMERCIAL}:faq.q2.title`;
  const faq_q2_children = `${Namespaces.EXP_COMMERCIAL}:faq.q2.children`;
  const faq_q3_title = `${Namespaces.EXP_COMMERCIAL}:faq.q3.title`;
  const faq_q3_children = `${Namespaces.EXP_COMMERCIAL}:faq.q3.children`;
  const faq_q4_title = `${Namespaces.EXP_COMMERCIAL}:faq.q4.title`;
  const faq_q4_children = `${Namespaces.EXP_COMMERCIAL}:faq.q4.children`;
  const faq_q5_title = `${Namespaces.EXP_COMMERCIAL}:faq.q5.title`;
  const faq_q5_children = `${Namespaces.EXP_COMMERCIAL}:faq.q5.children`;
  const faq_q6_title = `${Namespaces.EXP_COMMERCIAL}:faq.q6.title`;
  const faq_q6_children = `${Namespaces.EXP_COMMERCIAL}:faq.q6.children`;

  const faqConfig: FAQ = {
    title: faq_title,
    content: [
      {
        title: faq_q1_title,
        children: faq_q1_children,
      },
      {
        title: faq_q2_title,
        children: faq_q2_children,
      },
      {
        title: faq_q3_title,
        children: faq_q3_children,
      },
      {
        title: faq_q4_title,
        children: faq_q4_children,
      },
      {
        title: faq_q5_title,
        children: faq_q5_children,
      },
      {
        title: faq_q6_title,
        children: faq_q6_children,
      },
    ],
  };

  return faqConfig;
}
